import React, { useState } from 'react'
import Gallery1 from '../../Images/PhotoGallery/Darta.jpg'
import Gallery2 from '../../Images/PhotoGallery/KanakPAN.jpg'
import Gallery3 from '../../Images/PhotoGallery/G1.jpg'
import Gallery4 from '../../Images/PhotoGallery/Gallery4.jpg'
import Gallery5 from '../../Images/PhotoGallery/Gallery5.jpg'
import Gallery6 from '../../Images/PhotoGallery/G2.jpg'
import Gallery7 from '../../Images/PhotoGallery/G3.jpg'
import Gallery8 from '../../Images/PhotoGallery/G6.jpg'
import Gallery9 from '../../Images/PhotoGallery/G7.jpg'
import Gallery10 from '../../Images/PhotoGallery/G8.jpg'
import Gallery11 from '../../Images/PhotoGallery/G9.jpg'
import Gallery12 from '../../Images/PhotoGallery/G10.jpg'
import Gallery13 from '../../Images/PhotoGallery/G11.jpg'
import Gallery14 from '../../Images/PhotoGallery/G12.jpg'
import Gallery15 from '../../Images/PhotoGallery/G13.jpg'
import Gallery16 from '../../Images/PhotoGallery/G14.jpg'
import '../../css/coopgallery.css'

const CoopGallery = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState('');

    const galleryList = [
        {
            id: 1,
            galleryName: 'दर्ता',
            galleryImg: Gallery1
        },
        {
            id: 2,
            galleryName: 'कनक पान',
            galleryImg: Gallery2
        },
        {
            id: 3,
            galleryName: 'Gallery 3',
            galleryImg: Gallery3
        },
        {
            id: 4,
            galleryName: 'Gallery 4',
            galleryImg: Gallery4
        },
        {
            id: 5,
            galleryName: 'Gallery 5',
            galleryImg: Gallery5
        },
        {
            id: 6,
            galleryName: 'Gallery 6',
            galleryImg: Gallery6
        },
        {
            id: 7,
            galleryName: 'Gallery 7',
            galleryImg: Gallery7
        },
        {
            id: 8,
            galleryName: 'Gallery 8',
            galleryImg: Gallery8
        },
        {
            id: 9,
            galleryName: 'Gallery 9',
            galleryImg: Gallery9
        },
        {
            id: 10,
            galleryName: 'Gallery 10',
            galleryImg: Gallery10
        },
        {
            id: 11,
            galleryName: 'Gallery 11',
            galleryImg: Gallery11
        },
        {
            id: 12,
            galleryName: 'Gallery 12',
            galleryImg: Gallery12
        },
        {
            id: 13,
            galleryName: 'Gallery 13',
            galleryImg: Gallery13
        },
        {
            id: 14,
            galleryName: 'Gallery 14',
            galleryImg: Gallery14
        },
        {
            id: 15,
            galleryName: 'Gallery 15',
            galleryImg: Gallery15
        },
        {
            id: 16,
            galleryName: 'Gallery 16',
            galleryImg: Gallery16
        },
    ]

    const handleImageClick = (image) => {
        setCurrentImage(image);
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentImage('');
    }

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='branches-div'>
                        <div className='branches-body'>
                            <div className='card-container'>
                                {galleryList.map((item, id) => {
                                    return (
                                        <div className='card' key={id}>
                                            <div className='inner'>
                                                <div className='img-holder' onClick={() => handleImageClick(item.galleryImg)}>
                                                    <img src={item.galleryImg} alt='gallery-Image' />
                                                </div>
                                                <div className='detail'>
                                                    {/* <h3>{item.galleryName}</h3> */}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>

                {isModalOpen && (
                    <div className='modal'>
                        <span className='close' onClick={closeModal}>&times;</span>
                        <img className='modal-content' src={currentImage} alt='fullscreen' />
                    </div>
                )}

            </div>
        </>
    )
}

export default CoopGallery